import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Spin, Button } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SaveCurriculumVitae from './SaveCurriculumVitae';
import PersonalInfo from './PersonalInfo';
import WorkHistory from './WorkHistory';
import ClinicalTrialExp from './ClinicalTrialExp';
import Education from './Education';
import TrainingExp from './TrainingExp';
import SystemExp from './SystemExp';
import Licence from './Licence';
import Language from './Language';
import '../style/vitae.less';

class GenerateCurriculumVitae extends Component {
    state = {
        loading: false,
        languages: [],
        workExperiences: [],
        clinicalExperiences: [],
        educationBackgrounds: [],
        systemExperiences: [],
        trainingExperiences: [],
        licencesCertificates: [],
        crcUsedToBePm:false,
    }

    componentDidMount() {
        this.loadData();
    }

    componentWillUnmount(){
        sessionStorage.resumeRole = null;
    }
    
    loadData = () => {
        const { params: { userId, isChinese }, queryParams } = this.props;
        const {resumeRole} = sessionStorage;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeByUserId,
            data: {
                ...queryParams,
                userId,
                crcUsedToBePm:resumeRole == 'PM'?true:false,
                typeName: isChinese ? 'CHINESE' : 'ENGLISH',
            },
            dataType: 'json',
            doneResult: res => {
                const {
                    languages = [],
                    workExperiences = [],
                    clinicalExperiences = [],
                    educationBackgrounds = [],
                    systemExperiences = [],
                    trainingExperiences = [],
                    licencesCertificates = [],
                    crcUsedToBePm=null,
                } = res;

                this.setState({
                    loading: false,
                    languages,
                    workExperiences,
                    clinicalExperiences,
                    educationBackgrounds,
                    systemExperiences,
                    trainingExperiences,
                    licencesCertificates,
                    crcUsedToBePm,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    handleDelete = (id, type) => {
        const {
            workExperiences,
            clinicalExperiences,
        } = this.state;
        if (type === 'workHistory') {
            const index = workExperiences.findIndex(i => i.vitaeWorkExperienceId == id);
            if (index || index === 0) {
                workExperiences.splice(index, 1);
                this.setState({ workExperiences });
            }
        } else if (type === 'clinicalTrialExp') {
            const index = clinicalExperiences.findIndex(i => i.vitaeClinicalExperienceId == id);
            if (index || index === 0) {
                clinicalExperiences.splice(index, 1);
                this.setState({ clinicalExperiences });
            }
        }
    }

    leave = () => {
        window.history.go(-1);
    }

    save = () => {
        const { workExperiences, clinicalExperiences,crcUsedToBePm } = this.state;
        const { queryParams } = this.props;
        const {resumeRole} = sessionStorage;
        let workExperience = '';
        let clinicalExperience = '';
        if(resumeRole == 'PM' && workExperiences[0]){
            workExperiences[0].experienceInvs.forEach(i => {
                workExperience += workExperience ? `,${i.vitaeClinicalExperienceInvId}` : i.vitaeClinicalExperienceInvId;
            });
        }else{
            workExperiences.forEach(i => {
                workExperience += workExperience ? `,${i.vitaeWorkExperienceId}` : i.vitaeWorkExperienceId;
            });
        }
        clinicalExperiences.forEach(i => {
            clinicalExperience += clinicalExperience ? `,${i.groupKey}` : i.groupKey;
        });
        this.ref.show({ workExperience, clinicalExperience ,crcUsedToBePm, ...queryParams});
    }

    render() {
        const {
            loading,
            languages,
            workExperiences,
            clinicalExperiences,
            educationBackgrounds,
            systemExperiences,
            trainingExperiences,
            licencesCertificates,
            crcUsedToBePm,
        } = this.state;
        const { curRole } = sessionStorage;
        const { type, params: { userId, canEdit, isChinese } } = this.props;
        if (!userId) {
            if (type === 'user') {
                return <Redirect to="/user/userResume" />
            } else if (type === 'personal') {
                return <Redirect to="/personal/curriculumVitae" />
            }
        }
        return (
            <Spin spinning={loading}>
                <div className="curriculumVitae generate">
                    <div style={{ overflow: 'hidden' }}>
                        <div style={{ float: 'left', marginLeft: 10 }}>
                            <i
                                className="icon iconfont"
                                style={{ marginRight: 4, fontSize: '20px', color: '#1296DB'}}
                            >&#xe65b;</i>
                            {'生成简历'}
                        </div>
                        <div style={{ float: 'right', marginRight: 10, color: '#1296DB', cursor: 'pointer' }} onClick={this.leave}>
                            <i
                                className="icon iconfont"
                                style={{ marginRight: 4, fontSize: '20px' }}
                            >&#xe63d;</i>
                            返回
                        </div>
                    </div>
                    <div style={{ margin: '20px 10px', padding: '0 5px', maxHeight: 500, overflowY: 'auto' }}>
                        <div className="title">
                            <i className="icon iconfont">&#xe664;</i>
                            {isChinese ? '个人信息' : 'Personal Profile'}
                        </div>
                        <PersonalInfo userId={userId} isChinese={isChinese} />
                        <div className="title">
                            <i className="icon iconfont">&#xe70b;</i>
                            {isChinese ? '工作经历' : 'Work History'}
                        </div>
                        <WorkHistory canEdit={canEdit} isChinese={isChinese} crcUsedToBePm={crcUsedToBePm} data={workExperiences} delete={(id) => this.handleDelete(id, 'workHistory')} />
                        <div className="title">
                            <i className="icon iconfont">&#xe622;</i>
                            {isChinese ? '临床试验经验' : 'Clinical Trial Experience'}
                        </div>
                        <ClinicalTrialExp canEdit={canEdit} isChinese={isChinese} data={clinicalExperiences} delete={(id) => this.handleDelete(id, 'clinicalTrialExp')} />
                        <div className="title">
                            <i className="icon iconfont">&#xe61f;</i>
                            {isChinese ? '教育背景' : 'Education'}
                        </div>
                        <Education isChinese={isChinese} data={educationBackgrounds} />
                        <div className="title">
                            <i className="icon iconfont">&#xe61a;</i>
                            {isChinese ? '培训经历' : 'Training Experience'}
                        </div>
                        <TrainingExp isChinese={isChinese} data={trainingExperiences} />
                        <div className="title">
                            <i className="icon iconfont">&#xe631;</i>
                            {isChinese ? '使用系统经验' : 'System Experience'}
                        </div>
                        <SystemExp isChinese={isChinese} data={systemExperiences} />
                        <div className="title">
                            <i className="icon iconfont">&#xe63f;</i>
                            {isChinese ? '执照/许可证/证书' : 'Licences/Certificates'}
                        </div>
                        <Licence isChinese={isChinese} data={licencesCertificates} />
                        <div className="title">
                            <i className="icon iconfont">&#xe677;</i>
                            {isChinese ? '语言/流利度' : 'Languages/Fluency'}
                        </div>
                        <Language isChinese={isChinese} data={languages} />
                    </div>
                </div>
                {
                    (canEdit || (type === 'user' && curRole === 'FIN')) &&
                    <div style={{ textAlign: 'center' }}>
                        <Button type="primary" onClick={this.save}>保存简历</Button>
                    </div>
                }
                <SaveCurriculumVitae ref={el => this.ref = el} userId={userId} isChinese={isChinese} />
            </Spin>
        );
    }
}

const mapStateToProps = (state) => {
    const { personalState: { params, queryParams } } = state;
    return {
        params,
        queryParams,
    }
}

export default connect(mapStateToProps, null)(GenerateCurriculumVitae);


// WEBPACK FOOTER //
// ./src/components/common/generateCurriculumVitae/index.js